document.addEventListener('DOMContentLoaded',()=>{const t=document.querySelector('.menu-toggle'),n=document.querySelector('.nav');if(t&&n)t.addEventListener('click',()=>{const v=t.getAttribute('aria-expanded')==='true';t.setAttribute('aria-expanded',String(!v));n.classList.toggle('open',!v)})});
document.addEventListener('DOMContentLoaded',()=>{
  // Swipe a cart line right to reveal its remove panel
  document.querySelectorAll('[data-swipe-line]').forEach(line=>{
    const body=line.querySelector('.cart-line__body');if(!body)return;
    const REVEAL=176;let startX=0,startY=0,dx=0,dragging=false,open=false,suppress=false;
    const setX=x=>{body.style.transform='translateX('+x+'px)'};
    body.addEventListener('pointerdown',e=>{startX=e.clientX;startY=e.clientY;dragging=true;body.style.transition='none'});
    body.addEventListener('pointermove',e=>{
      if(!dragging)return;
      const mx=e.clientX-startX,my=e.clientY-startY;
      if(Math.abs(my)>Math.abs(mx)&&Math.abs(my)>8){dragging=false;setX(open?REVEAL:0);return}
      dx=Math.max(0,Math.min(REVEAL,(open?REVEAL:0)+mx));setX(dx);
    });
    const end=()=>{if(!dragging)return;dragging=false;body.style.transition='';const was=Math.abs(dx-(open?REVEAL:0))>10;open=dx>REVEAL*0.45;setX(open?REVEAL:0);dx=open?REVEAL:0;if(was)suppress=true};
    body.addEventListener('pointerup',end);
    body.addEventListener('pointercancel',end);
    body.addEventListener('click',e=>{
      if(suppress){e.preventDefault();e.stopPropagation();suppress=false;return}
      if(open&&!e.target.closest('a,input,button,label,select')){open=false;dx=0;setX(0)}
    },true);
  });
  // Product photo lightbox: tap a gallery photo, swipe through them all
  const lb=document.getElementById('gl-lightbox');
  if(lb){
    const track=lb.querySelector('[data-lb-track]'),cur=lb.querySelector('[data-lb-current]'),slides=lb.querySelectorAll('.gl-lightbox__slide');
    const openAt=i=>{lb.hidden=false;document.body.style.overflow='hidden';requestAnimationFrame(()=>{track.scrollTo({left:track.clientWidth*i,behavior:'auto'});if(cur)cur.textContent=i+1})};
    const closeLb=()=>{lb.hidden=true;document.body.style.overflow=''};
    document.querySelectorAll('.product-gallery img').forEach((im,i)=>im.addEventListener('click',()=>openAt(i)));
    lb.querySelector('[data-lb-close]').addEventListener('click',closeLb);
    lb.addEventListener('click',e=>{if(e.target===lb)closeLb()});
    document.addEventListener('keydown',e=>{
      if(lb.hidden)return;
      if(e.key==='Escape')closeLb();
      if(e.key==='ArrowRight')track.scrollBy({left:track.clientWidth,behavior:'smooth'});
      if(e.key==='ArrowLeft')track.scrollBy({left:-track.clientWidth,behavior:'smooth'});
    });
    let raf=0;
    track.addEventListener('scroll',()=>{cancelAnimationFrame(raf);raf=requestAnimationFrame(()=>{const i=Math.round(track.scrollLeft/Math.max(1,track.clientWidth));if(cur)cur.textContent=Math.min(slides.length,Math.max(1,i+1))})});
  }
});
